if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();
      this.updateVisibility = this.updateVisibility.bind(this);

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.variantChanged = (event) => { this.productSection.dataset.mobileVariantChosen = String(!!event.detail?.variant); this.updateVisibility(); };
      this.productSection.addEventListener('on:variant:change', this.variantChanged);

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateVisibility);
      window.removeEventListener('resize', this.updateVisibility);
      this.observer?.disconnect();
      this.productSection.removeEventListener('on:variant:change', this.variantChanged);
    }

    bindEvents() {
      this.observer = new IntersectionObserver(this.updateVisibility);
      const purchase = this.productSection.querySelector('.pc .pa button');
      if (purchase) this.observer.observe(purchase);
      window.addEventListener('scroll', this.updateVisibility, { passive: true });
      window.addEventListener('resize', this.updateVisibility);
      this.updateVisibility();
    }

    /**
     * Keep the purchase action available after its form has left the viewport.
     */
    updateVisibility() {
      const picker = this.productSection.querySelector('variant-picker');
      const ready = this.dataset.r20NeedsVariant !== 'true' || !!picker?.variant;
      const mobile = matchMedia('(max-width:768px)').matches;
      const purchase = this.productSection.querySelector('.pc .pa button');
      const bounds = purchase?.getBoundingClientRect();
      const formVisible = bounds && bounds.bottom > 0 && bounds.top < innerHeight;
      this.toggleAttribute('data-r20-ready', ready);
      this.classList.toggle(
        'sticky-atc-panel--out',
        mobile ? !!formVisible : (!this.productForm || this.productForm.getBoundingClientRect().bottom > 0)
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
